import React from 'react';
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
  Avatar
} from '@mui/material';
import {
  Person,
  Work,
  Message,
  CreditCard,
  ArrowForward
} from '@mui/icons-material';
import './TutorialCard.css';

const TutorialCard = ({ tutorial, onClick }) => {
  const getIcon = (iconName) => {
    const iconProps = {
      sx: { fontSize: 32, color: 'primary.main' }
    };
    
    switch (iconName) {
      case 'user':
        return <Person {...iconProps} />;
      case 'briefcase':
        return <Work {...iconProps} />;
      case 'message':
        return <Message {...iconProps} />;
      case 'credit-card':
        return <CreditCard {...iconProps} />;
      default:
        return <Person {...iconProps} />;
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick(tutorial);
    } else {
      // Default behavior: navigate to tutorial page
      window.location.href = `/aide/${tutorial.slug}`;
    }
  };

  return (
    <Card 
      className="tutorial-card"
      sx={{
        height: '100%',
        borderRadius: 3,
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          transform: 'translateY(-4px)'
        }
      }}
    >
      <CardActionArea 
        onClick={handleClick}
        sx={{ 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'flex-start',
          p: 0
        }}
        aria-label={`Accéder au tutoriel : ${tutorial.title}`}
      >
        <CardContent 
          sx={{ 
            p: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
          {/* Icon */}
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: 'primary.light',
              mb: 2
            }}
          >
            {getIcon(tutorial.icon)}
          </Avatar>
          
          {/* Title */}
          <Typography 
            variant="h6" 
            component="h3"
            sx={{ 
              fontWeight: 600,
              mb: 1,
              color: 'text.primary',
              lineHeight: 1.3
            }}
          >
            {tutorial.title}
          </Typography>
          
          {/* Description */}
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'text.secondary',
              mb: 2,
              flexGrow: 1,
              lineHeight: 1.5
            }}
          >
            {tutorial.description}
          </Typography>
          
          {/* Action indicator */}
          <Box 
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'primary.main',
              fontWeight: 600,
              fontSize: '0.9rem'
            }}
          >
            <span>Voir le guide</span>
            <ArrowForward sx={{ ml: 1, fontSize: 18 }} />
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default TutorialCard;